import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { filter } from 'rxjs';
import { CameraUploadComponent } from 'src/app/dialogs/camera-upload/camera-upload.component';
import { onErrorImage } from '@global/GlobalFunctions';

/**
 * 
 */
@Component({
	selector: 'app-image-container',
	templateUrl: './image-container.component.html',
	styleUrls: ['./image-container.component.scss']
})
export class ImageContainerComponent {

	/*/ ✅ Inputs (data passed in from parent) */
	@Input() imgURL: string | null = null;
	/*/ Alternative text for the image */
	@Input() altText: string = 'Image'
	/** Show/Hide the buttons */
	@Input() displayButtons: boolean = true;
	/** new Image Selected */
	@Input() newImage: boolean = false;

	/** Enable the New Picture Button */
	@Input() enablePicture:boolean | null = true
	/** Enable the Camera Button */
	@Input() enableCamera:boolean | null = true
	/** Enable the Delete Button */
	@Input() enableDelete:boolean | null = true

	// ✅ Outputs (events exposed to parent)
	@Output() onDelete = new EventEmitter<void>();
	/*/ When the user saves the new image */
	// @Output() onSave = new EventEmitter<File>();
	/*/ When the user selects a new image */
	@Output() onNewImage = new EventEmitter<File>();

	/** File */
	public file: any
	/** Filename */
	public fileName: string
	/** Default Image Error Path */
	public onErrorImage = onErrorImage;

	/**
	   * Default Constructor
	   * @param dialog object interface
	   * @param cdr ChangeDetectorRef
	   */
	constructor(
		public dialog: MatDialog,
		private cdr: ChangeDetectorRef
	) {
		// console.log(this.imgURL);
	}

	/**
	 * Delete Button Clicked
	 */
	deleteClick() {
		this.onDelete.emit();
	}

	/**
	 * Open the Camera Dialog
	 */
	cameraClick() {
		// Create a 'Local'/shallow copy of the location Information
		var _edit = {};

		// Display the dialog box
		const dialogRef = this.dialog.open(CameraUploadComponent, {
			data: _edit,
		});

		// Update the original Location with the result
		dialogRef.afterClosed().pipe(
			filter(result => !!result)
		).subscribe(result => {
			// console.log('The dialog was closed');
			// Check we have a result to work with
			this.file = result["file"];
			this.fileName = this.file.name;
			this.newImage = true;

			if (this.file) {
				this.imgURL = URL.createObjectURL(this.file); // Create a URL for the image file
				this.cdr.detectChanges();
			}

			this.onNewImage.emit((this.file) ? this.file : null);

		});
	}

	// /**
	//  * Save Button Clicked
	//  */
	// saveclick() {
	// 	this.onSave.emit((this.file) ? this.file : null);
	// }

	/**
	 * New File Selected
	 * @param fileInput 
	 */
	imgChange(fileInput: any): void {
		let input = fileInput.target as HTMLInputElement;

		// console.log(this.organisation.Id)
		if (input.files && input.files[0]) {
			this.file = undefined;
			this.fileName = "";
			this.file = input.files[0];

			const reader = new FileReader();
			reader.onload = (e: ProgressEvent<FileReader>) => {
				const previewImage = document.getElementById("editing-image") as HTMLImageElement;
				if (e.target && e.target.result) {
					previewImage.src = e.target.result as string;
				}
			};
			reader.readAsDataURL(this.file);
			// Extract and store the file name
			this.fileName = this.file.name;
			input.files = null; // Clear the input value to allow re-selection of the same file if needed
			// this.dialogForm.markAsDirty();
			this.newImage = true;
			this.onNewImage.emit((this.file) ? this.file : null);
		}
	}
}
